import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatTabsModule } from "@angular/material/tabs";
import { MatDivider } from "@angular/material/divider";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RekbotNotesService } from '../../../services/rekbots-notes.service';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatCheckbox } from "@angular/material/checkbox";
import { RekbotNote } from '../rekbot-layout-models/rekbot-note.model';
import { NotificationService } from '../../../services/notification.service';
import { RekbotNoteStateService } from '../rekbot-layout-services/rekbot-note-state.service';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/user.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalNoteDeleteConfirmComponent } from './modal-note-delete-confirm/modal-note-delete-confirm.component';

@Component({
  selector: 'app-rekbot-notes',
  imports: [
    MatTabsModule,
    MatCardModule,
    MatButtonModule,
    MatIcon,
    MatTooltipModule,
    CommonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RouterLink
],
  templateUrl: './rekbot-notes.component.html',
  styleUrl: './rekbot-notes.component.css'
})
export class RekbotNotesComponent implements OnInit {

  user: User = new User(0,'','','',0,'');

  notes: RekbotNote[] = [];
  serviceEntry: RekbotNote[] = [];
  filter: FormControl = new FormControl('');
  rekbotId!: number;
  selectedNoteIndex = 0;

  constructor(
    private rekbotNotesService: RekbotNotesService,
    private route : ActivatedRoute,
    private router: Router,
    private noificationService: NotificationService,
    private rekbotNoteStateService: RekbotNoteStateService,
    private authService: AuthService,
    readonly dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.rekbotId = this.route.parent?.snapshot.params['rekbotId'];
    this.fetchNotes();
    this.selectedNoteIndex = Number(localStorage.getItem('notesTabIndex')) || 0;
    this.user = this.authService.getUser()!;
  }

  fetchNotes() {
    this.rekbotNotesService.getNotes(this.rekbotId).subscribe({
      next: notes => {
        console.log("Notatki wgrane dla urządznia z id: "+ this.rekbotId, notes);
        this.notes = notes.filter(note => note.note_type == "note");
        this.serviceEntry = notes.filter(note => note.note_type == "service_entry")
      }
    })
  }

  onDeleteNote(noteId: number) {
    // console.log('Kliknięto usuń');
    if(confirm("Czy chcesz usunąć notatke?")) {
      console.log("potwierdzono usunięcie");
      this.rekbotNotesService.deleteNote(this.rekbotId, noteId)
      .subscribe({
        next: () => {
          this.noificationService.pushNotification("Notatka usunięta","info",5000);
          this.fetchNotes();
        },
        error: err => {
          this.noificationService.pushNotification("Błąd podczas usuwania notatki","error",5000);
          console.error(err);
        }
      })
    }
  }

  onEdit(noteId: number) {
    this.rekbotNoteStateService.setEditing(true);
    this.router.navigate(['show', noteId], { relativeTo: this.route });
  }

  saveFilter() {

  }

  onTabChange(event: any) {
    localStorage.setItem('notesTabIndex', event.index);
  }

  onRequestDelete(noteId: number) {
    this.dialog.open(ModalNoteDeleteConfirmComponent, {
      width: '400px',
      data: { noteId: noteId, rekbotId: this.rekbotId }
    }).afterClosed().subscribe(result => {
      if (result === "success") {
        this.fetchNotes();   // funkcja w rodzicu
      } else {
        console.log("Usunięcie notatki anulowane lub wystąpił błąd");
      }
    });
  }


  
}
